<script setup>
import { watch } from 'vue'
import { useRouter } from 'vue-router'
import AppFooter from './components/common/AppFooter.vue'
import AppNav from './components/common/AppNav.vue'
import UserSessionToast from './components/common/user-session/UserSessionToast.vue'
import { useUserStore } from './stores/user'

const userStore = useUserStore()
const router = useRouter()

let rerouted = false

watch(
  () =>
    userStore.signedIn
      ? 's' +
        (userStore.customerId ? `:${userStore.customerId}:` : ':') +
        (userStore.twoFactorAuthSetUp ? 't' : 'f') +
        (userStore.twoFactorAuthVerified ? 't' : 'f')
      : '',
  () => {
    const route = document.documentElement.getAttribute('data-route')

    if (userStore.signedIn) {
      if (!userStore.twoFactorAuthSetUp) {
        router.push({ name: 'two_factor_auth_set_up' })
      } else if (!userStore.twoFactorAuthVerified) {
        router.push({ name: 'two_factor_auth_verify' })
      } else if (userStore.customerId) {
        if (!rerouted) {
          // hack, not sure why redirect is necessary
          if (route === 'installations' && userStore.customerUrlSlug) {
            router.replace({
              name: route,
              params: { customerUrlSlug: userStore.customerUrlSlug }
            })
          }
          if (route === 'planning' && userStore.customerUrlSlug) {
            router.replace({
              name: route,
              params: { customerUrlSlug: userStore.customerUrlSlug }
            })
          }

          if (route === 'administer_users') {
            router.replace({ name: route })
          }

          rerouted = true
        } else {
          if (route.path === '/') {
            router.replace({
              name: route,
              customerUrlSlug: userStore.customerUrlSlug
            })
          }
        }
      } else if (route === 'administer-users') {
        if (!userStore.isAdmin) {
          userStore.unsetUser()
          router.push({ name: 'sign_in' })
        } else {
          // do nothing
        }
      } else if (!userStore.customerId) {
        router.push({ name: 'switch_customer' })
      } else {
        router.push({ name: 'sign_in' })
      }
    } else {
      router.push({ name: 'sign_in' })
    }
  },
  { immediate: true }
)
</script>

<template>
  <div class="is-flex is-flex-direction-column app-page">
    <template v-if="userStore.signedIn">
      <AppNav />
    </template>

    <div class="app-content is-flex-grow-1 is-relative">
      <router-view />

      <UserSessionToast />
    </div>

    <div class="app-footer">
      <AppFooter />
    </div>
  </div>
</template>

<style scoped>
.app-page {
  min-height: 100vh;
}

.app-footer {
  font-size: 90%;
}
</style>
